export default __webpack_public_path__ + "static/media/fc-2.04cd7e0a.png";